import React, {useEffect, useState} from "react";
import {
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Table,
    TableCell,
    TableRow
} from "@material-ui/core";

import { EvaWaiver } from "./EvaWaiver";

export function EvaWaiverDialog(props){
    const {onDock} = props;
    const [open,setOpen] = useState(false);
    const [onOk, setOnOk] = useState(() => () => alert("no onOk set"));
    const [evaWaiver,setEvaWaiver] = useState(false);
    const show = (evaWaiver, onOk) => {setOpen(true); setEvaWaiver(evaWaiver); setOnOk(() => onOk)};

    useEffect(() => {
        onDock(show);
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    return <Dialog open={open} onclose={() => setOpen(false)} 
        fullWidth maxWidth="lg"
    >
        <DialogTitle>New Waiver</DialogTitle>
        <DialogContent>
            <DialogContentText>

            </DialogContentText>
            <EvaWaiver/>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={() => {
                
                setOpen(false);
                onOk(evaWaiver);
            }}>OK</Button>
        </DialogActions>
    </Dialog>
}